import { formatApiError } from "@/lib/api";

// Runs a diary save; on a clash (409) asks the user and retries with force=true.
export async function withOverride(send) {
  try { return await send(false); }
  catch (err) {
    if (err.response?.status !== 409) throw err;
    const msg = formatApiError(err.response?.data?.detail);
    if (!window.confirm(`Warning: ${msg}\n\nBook it anyway?`)) { const e = new Error("cancelled"); e.cancelled = true; throw e; }
    return send(true);
  }
}
